/**
 * ConferirButton — marca/desmarca a visita como conferida (RF-M8-005, US-05,
 * US-08). Só visível para editor/admin (perfil consulta não vê). O row_version
 * corrente é enviado para o controle de concorrência (RN-M8-004).
 */

export interface ConferirButtonProps {
  readonly conferida: boolean;
  readonly salvando: boolean;
  readonly onConferir: () => void;
}

export function ConferirButton(props: ConferirButtonProps): JSX.Element {
  return (
    <button
      type="button"
      className={props.conferida ? 'btn btn-ghost' : 'btn btn-primary'}
      onClick={props.onConferir}
      disabled={props.salvando}
    >
      {props.salvando
        ? 'Salvando…'
        : props.conferida
          ? 'Desmarcar conferida'
          : 'Marcar como conferida'}
    </button>
  );
}
